import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  changeDeal,
  setIsRentCalculated,
  setLeaseRateUnits,
  setLeaseTerms,
} from 'bundles/apex/deals/form/store/deal/actions';

import CommissionMode from 'bundles/apex/deals/form/fields/gross_commission/mode';
import LeaseTerms from 'bundles/apex/deals/lease_terms';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import { Button } from 'components/ui/button';
import { leaseRateUnitOptions } from 'components/lease_structure/form/helpers/select_options';

export function LeaseStructureEditModal({
  changeDeal,
  deal,
  features,
  setIsRentCalculated,
  setLeaseRateUnits,
  setLeaseTerms,
  show,
  onClose,
}) {
  return (
    <Modal
      className="lease-structure-table-wrapper"
      // The lease term date calendars render in a portal, outside the modal.
      enforceFocus={false}
      show={show}
      size="lg"
      onHide={onClose}
    >
      <Modal.Header closeButton>
        Edit Rent Schedule
      </Modal.Header>

      <Modal.Body className="d-flex flex-column gap-4">
        <div>
          <ManagedFormGroup
            name="leaseRateUnits"
            type="select"
            value={deal.leaseRateUnits}
            onValueChange={setLeaseRateUnits}
          >
            {leaseRateUnitOptions({ spaceSizeUnits: deal.spaceSizeUnits }).map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </ManagedFormGroup>

          <CommissionMode/>
        </div>

        <LeaseTerms
          changeDeal={changeDeal}
          deal={deal}
          enableOperatingExpenses={features.operatingExpenses}
          onChange={setLeaseTerms}
          onIsRentCalculatedChange={setIsRentCalculated}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button label="OK" onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
}

LeaseStructureEditModal.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  deal: PropTypes.shape({
    leaseRateUnits: PropTypes.string,
    spaceSizeUnits: PropTypes.string,
  }).isRequired,
  features: PropTypes.shape({
    operatingExpenses: PropTypes.bool,
  }).isRequired,
  setIsRentCalculated: PropTypes.func.isRequired,
  setLeaseRateUnits: PropTypes.func.isRequired,
  setLeaseTerms: PropTypes.func.isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  features: state.features,
});

const mapDispatchToProps = {
  changeDeal,
  setIsRentCalculated,
  setLeaseRateUnits,
  setLeaseTerms,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaseStructureEditModal);
